module.exports = __webpack_public_path__ + "static/media/LogIn_background.98e23845.jpg";